var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { PopoverPanel, Paper, Scrollbars, useHoneycombTheme, Styler } from '@honeycomb/ui-core';
import { SEARCH_FIELD_POPOVER_INNER_PADDING, SEARCH_FIELD_SIZE } from '../../../../utils/style-constants';
import { useSearchFieldPopoverContext } from './SearchFieldPopover.context';
export function SearchFieldPopoverPanel(_a) {
    var { children, width, scrollingElementRef, disableScroll } = _a, other = __rest(_a, ["children", "width", "scrollingElementRef", "disableScroll"]);
    const context = useSearchFieldPopoverContext();
    const { theme } = useHoneycombTheme();
    const fieldHeight = theme.components.themes.FieldBase.size[SEARCH_FIELD_SIZE].height;
    const innerPadding = SEARCH_FIELD_POPOVER_INNER_PADDING * theme.spacingUnit;
    return (React.createElement(PopoverPanel, null,
        React.createElement(Paper, Object.assign({ ref: context === null || context === void 0 ? void 0 : context.setRootElement, cornerStyle: "rounded" // force rounded corners for all brands
            , border: 1, shadow: "l", bg: "background.offset", display: "flex", flexDirection: "column", w: width, mih: (context === null || context === void 0 ? void 0 : context.variant) === 'wrapping-field' ? 240 : 100, overflow: "hidden" }, other),
            React.createElement(React.Fragment, null,
                (context === null || context === void 0 ? void 0 : context.variant) === 'wrapping-field' && (React.createElement(Styler, { h: `${fieldHeight + innerPadding * 2}px`, bg: "background.content", flexShrink: 0 })),
                React.createElement(Scrollbars, { ref: scrollingElementRef, p: SEARCH_FIELD_POPOVER_INNER_PADDING, 
                    // pr={0} // Let the scrollbar serve as righthand padding
                    scrollbarEndMargin: SEARCH_FIELD_POPOVER_INNER_PADDING, disabled: disableScroll, flexGrow: 1 }, children)))));
}
